module.exports = __webpack_public_path__ + "img/trips-1.898a3493.gif";